import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { NdcRegistrationManualPage } from 'src/app/model/page/group/iag-portal/ndc-registration-manual-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-ndc-registration-manual-page',
  templateUrl: './ndc-registration-manual-page.component.html',
  styleUrls: ['./ndc-registration-manual-page.component.scss']
})
export class NdcRegistrationManualPageComponent implements OnInit {
  ndcRegistrationManualPage: NdcRegistrationManualPage = {} as NdcRegistrationManualPage;
  constructor(private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'iag-portal-manual') {
        this.ndcRegistrationManualPage.htmlTitle = title.htmlTitle;
      }
    });
    this.ndcRegistrationManualPage.cardSectionsMap = new Map<string, any[]>();
    const query = { 'fields.title': 'NDC Registration Manual' };
    this.contentfulService.getPageContentResponse(query).then((ndcRegistrationManualPageEntries) => {
      this.mapHtmlTitle(ndcRegistrationManualPageEntries.items);
      this.mapBanner(ndcRegistrationManualPageEntries.includes.Entry);
      this.mapCards(ndcRegistrationManualPageEntries.includes.Entry);
      this.mapNoteSections(ndcRegistrationManualPageEntries.includes.Entry);
    });
  }

  private mapHtmlTitle(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.ndcRegistrationManualPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapBanner(ndcRegistrationManualPageEntries: Entry<any>[]) {
    ndcRegistrationManualPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {

    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];

    this.ndcRegistrationManualPage.banner = {
      title: entry.fields['title']as string,
      subTitle: entry.fields['subTitle']as string,
      image: imageDetails.fields.file.url,
      video: videoDetails?.fields?.file?.url
    };
  }

  private mapCards(ndcRegistrationManualPageEntries: Entry<any>[]) {
    ndcRegistrationManualPageEntries
      .filter((entry) => ModelValidator.isCard(entry))
      .forEach((entry) => {
        if (entry.fields['group']) {
          this.mapCardSections(entry);
        }
      });
  }

  private mapNoteSections(ndcRegistrationManualPageEntries: Entry<any>[]) {
    ndcRegistrationManualPageEntries
      .filter((entry) => ModelValidator.isNote(entry))
      .forEach((entry) => {
        this.mapNote(entry);
      });
  }

  private mapNote(entry: Entry<any>) {
    let isNoteSectionAdded = false;
    let title:any =  entry.fields['title'] as string;
    this.ndcRegistrationManualPage.cardSectionsMap.forEach((value, key) => {
      value.forEach((cards: any) => {
        cards.forEach((card: any) => {
          if (entry.fields['group'] === card.group && !isNoteSectionAdded) {
            card.noteSections.push({
              title: title.split('#').pop(),
              body: entry.fields['body'],
              group: entry.fields['group'],
              category: entry.fields['category'],
              order: entry.fields['order'],
              fullTitle: entry.fields['title'],
              iconClass: entry.fields['iconClass']
            });
            isNoteSectionAdded = true;
          }
        });
      });
    });
  }

  private mapCardSections(entry: Entry<any>) {
    this.ndcRegistrationManualPage.cardData = [];
    let headImage:any = entry.fields['headImage'] as string;
    this.ndcRegistrationManualPage.cardData.push({
      title: entry.fields['title'] as string,
      order: entry.fields['order'] as number,
      richTextBody: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      headText: entry.fields['headText'] as string,
      headImage: headImage.fields.file.url,
      sectionOrder: entry.fields['additionalOrder'] as number,
      noteSections: []
    });
    let cardSectionName = entry.fields['group'] as string;
    if (this.ndcRegistrationManualPage.cardSectionsMap.has(cardSectionName)) {
      let dataForExistingCardSection = [this.ndcRegistrationManualPage.cardData, ...(this.ndcRegistrationManualPage.cardSectionsMap.get(cardSectionName) || [])].sort(
        (a, b) => a[0].order - b[0].order
      );
      this.ndcRegistrationManualPage.cardSectionsMap.set(cardSectionName, dataForExistingCardSection);
    } else {
      this.ndcRegistrationManualPage.cardSectionsMap.set(cardSectionName, [this.ndcRegistrationManualPage.cardData]);
    }
  }
}
